import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ViUIService } from '../../services/ui.service';

@Component({
  selector: 'vi-sidenav-button',
  templateUrl: './sidenav-button.component.html',
  styleUrls: ['./sidenav-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViSidenavButtonComponent {
  constructor(private uiService: ViUIService) {}

  toggleMenu(): void {
    this.uiService.sidenav$.next();
  }
}
